import { JustfiIntegration } from '@weave/schema-gen-ts/dist/schemas/payments-platform/justifi-integration/justifi_integration.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaJustfiIntegration1Service = bindHTTP(JustfiIntegration);
export const serviceName = 'justfi-integration1' as const;
